<script lang="ts">import { stateUi } from "@infinitro/config";
import { isNotificationsOpen } from "@infinitro/global";
import { NotificationsIcon } from "@infinitro/icons";
import { GradientBorder } from "@infinitro/info-card";
import { derived } from "svelte/store";
import { markAllAsRead, notificationsStore } from "./state";
const notificationsLength = derived(notificationsStore, ($store) => $store.filter((n) => n.read === false).length);
export let onShowNotifications;
const handleClick = () => {
	if ($notificationsLength > 0) markAllAsRead();
	onShowNotifications?.();
};
$: useAlternative = $stateUi.header.headerStyle === "alternative";
$: useAlternative2 = $stateUi.header.headerStyle === "alternative2";
$: useAlternative4 = $stateUi.header.headerStyle === "alternative4";
</script>

<!-- svelte-ignore a11y-click-events-have-key-events -->
<!-- svelte-ignore a11y-no-static-element-interactions -->
<GradientBorder
	radius="var(--border-radius-header-chat-notifications)"
	gradient="linear-gradient(180deg, rgba(255,255,255,0.1) 0%, rgba(255,255,255,0) 100%)"
	isEnabled={!useAlternative4}
>
	<div
		class:active={$isNotificationsOpen}
		class="notifications-container"
		class:alternative-notifications-container={useAlternative || useAlternative4}
		class:alternative-notifications-container-4={useAlternative4}
		class:alternative-notifications-container-2={useAlternative2}
		on:click={handleClick}
	>
		<NotificationsIcon active={$notificationsLength > 0} />
		{#if $notificationsLength > 0}
			<span class="notification-count" class:notification-count-alternative-4={useAlternative4}
				>{$notificationsLength}</span
			>
		{/if}
	</div>
</GradientBorder>

<style>
	.notifications-container {
		position: relative;
		display: flex;
		height: 3rem;
		width: 3rem;
		cursor: pointer;
		align-items: center;
		justify-content: center;
		background-color: var(--color-background-900);
		padding: 0px;
		border-top-width: 1px;
		border-color: var(--color-neutral-900);
		--tw-text-opacity: 1;
		color: rgb(255 255 255 / var(--tw-text-opacity, 1));
		border-radius: var(--border-radius-header-chat-notifications)
}
	.notifications-container.active {
		color: var(--color-primary-500)
}

	.notification-count {
		position: absolute;
		top: 0px;
		right: 0px;
		display: flex;
		height: 1rem;
		width: 1rem;
		align-items: center;
		justify-content: center;
		border-radius: 0.375rem;
		font-size: 0.75rem;
		line-height: 1rem;
		--tw-text-opacity: 1;
		color: rgb(255 255 255 / var(--tw-text-opacity, 1));
		font-family: var(--font-main);
		transform: translate(35%, -35%);
		background-color: var(--color-primary-500)
}

	.notification-count-alternative-4 {
		height: 1.25rem;
		width: 1.25rem;
		border-radius: 9999px;
		background: var(--component-header-profile-notification-background, var(--color-accent-700));
		color: var(--component-header-profile-notification-text, #000)
}

	.alternative-notifications-container {
		border-color: var(--color-accent-700);
		background-color: var(--color-tertiary-500);
		border-width: 1px
}

	.alternative-notifications-container-4 {
		border-width: 0px
}

	.alternative-notifications-container-2 {
		height: 40px;
		width: 40px;
		background-color: transparent;
		background: var(--gradient-alternative-5)
}
</style>
